/**
 * System Notices admin list view — chrome shell for the system banner grid.
 * Hosts AppNav, TitleBar with conditional create button, and the grid component.
 */

import { Add as AddIcon } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useUser } from '@sophocles/app';
import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';
import SystemNoticesGrid from '@sophocles/views/admin/components/SystemNoticesGrid';

const SystemNoticesGridView = props => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { permissions } = useUser();

  const canEdit = permissions.isODLEngineering || permissions.isAccounting;

  return (
    <AppNav page="admin_home" notFullHeight flex {...props}>
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
        <TitleBar
          title={t('systemNotices.pageTitle', 'System Notices')}
          actions={
            canEdit ? (
              <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate('/staff/systemnotices/new/')}>
                {t('systemNotices.createNotice', 'System Notice')}
              </Button>
            ) : null
          }
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minHeight: 0,
            px: 'var(--page-px)',
            pb: 'var(--page-py)',
          }}
        >
          <SystemNoticesGrid />
        </Box>
      </Box>
    </AppNav>
  );
};

export default SystemNoticesGridView;
